import { useParams } from 'react-router';
import isError404 from '@/common/utils/is-error404';
import { hereMapsApi } from '@/app/services/hereMaps';
import { microsoftApi } from '@/app/services/microsoft';
import { solutionApi } from '@/app/services/solution';
import { useAppSelector } from '@/app/hooks';

const useGlobalIsError = (): boolean => {
  const { depotId } = useParams();

  return useAppSelector((state) => {
    return [solutionApi, solutionApi, microsoftApi, hereMapsApi].some((api) => {
      const hasQueryError = Object.values(state[api.reducerPath].queries).some((query) => {
        if (!query) {
          return false;
        }

        // RTK Query does an unwanted getDepot API call after deleting the depot
        const suppressErrorAfterDeletingDepot = query.endpointName === 'getDepot' && !depotId;

        if (suppressErrorAfterDeletingDepot || isError404(query.error)) {
          return false;
        }

        return Boolean(query.error);
      });
      const hasMutationError = Object.values(state[api.reducerPath].mutations).some((mutation) => {
        return mutation?.error;
      });

      return hasQueryError || hasMutationError;
    });
  });
};

export default useGlobalIsError;
